function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed"; //avoid scrolling to bottom
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    // var successful = document.execCommand("copy");
    // var msg = successful ? "successful" : "unsuccessful";
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
  }

  document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
    function() {},
    function(err) {
      console.error("Async: Could not copy text: ", err);
    }
  );
}
function regexFormat(text){
  var newString =text
  .replace(
    /<u style="font-style: italic;">(.*?)<\/u>/gi,
    "<u><i>$1</i></u>"
  )
  .replace(
    /<u style="font-weight: bold; font-style: italic;">(.*?)<\/u>/gi,
    "<u><i><b>$1</b></i></u>"
  )
  .replace(/<u style="font-weight: bold;">(.*?)<\/u>/gi, "<u><b>$1</b></u>")
  .replace(
    /<i style="font-weight: bold;">(.*?)<\/i>/gi,
    "<i><b>$1</b></i>"
  )
  .replace(/span style="font-weight: 600;"/gi, "b")
  .replace(/span/gi, "b")
  .replace(/style="font-weight: 600;"/gi, "")
  .replace(/<br>/gi, "\n")

  return newString
}

export { copyTextToClipboard,regexFormat };